import { initializeApp } from 'firebase/app';

/* eslint-disable sort-keys */
const firebaseConfig = {
  apiKey: 'AIzaSyC0Pv1vun9qS0AixzBAuGWa8h8yhfvwrO4',
  authDomain: 'youversion-base.firebaseapp.com',
  databaseURL: 'https://youversion-base.firebaseio.com',
  projectId: 'youversion-base',
  storageBucket: 'youversion-base.appspot.com',
  messagingSenderId: '201895780642',
  appId: '1:201895780642:web:f9ed21f6a8d67a6cfb057b',
  measurementId: 'G-H2ZTXKPWBP',
};
export const firebaseApp = initializeApp(firebaseConfig);
